import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';

export const BadgeText = styled.p.attrs({
  className: 'tl-header-xs text-white'
})`
  padding: 2px 16px;
`;

const Wrapper = styled.div.attrs({
  className: 'w-fit',
  'data-qa': 'hero-header-badge'
})`
  height: 24px;
  border-radius: 3px;
`;

export const BlueWrapper = createComponent(Wrapper, {
  className: 'bg-blue-2'
});

export const RedWrapper = createComponent(Wrapper, {
  className: 'bg-red-2'
});

export const YellowWrapper = createComponent(Wrapper, {
  className: 'bg-yellow-2'
});
